import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setIsCustomTime } from 'cogsworth/utils/store'
import MonthView from './MonthView/MonthView'
import TimezonePicker from './TimezonePicker/TimezonePicker'
import AdHocView from './AdHocView/AdHocView'
import RequestTime from './RequestTime/RequestTime'

import './date.css'
import { DEFAULT_TIME_REQUEST_BUTTON_LABEL } from 'cogsworth/constants'

class InputDate extends Component {

  constructor(props){
    super(props)

    const serviceId = this.props.fields.find(f => f.id === "booking_service").value
    const service = this.props.business.services.find(s => s.id === serviceId)

    this.state = {
      service,
    }

    this.handleConfirm = this.handleConfirm.bind(this)
    this.toggleCustomTime = this.toggleCustomTime.bind(this)
  }

  getCalendarView({ business }){
    if(!business.availableFeatures.calendarView) {
      return "WEEK"
    }

    if(business.calendarView) {
      return business.calendarView
    }

    return "WEEK"
  }

  handleConfirm(time){
    this.props.onSubmit(time)
  }

  toggleCustomTime() {
    this.props.dispatch(setIsCustomTime(!this.props.isCustomTime))
  }

  renderCustomTime() {
    if (!this.props.isCustomTime) {
      return null
    }

    return (
      <RequestTime
        business={this.props.business}
        service={this.state.service}
        set={this.handleConfirm}
        cancel={this.toggleCustomTime}
      />
    )
  }

  renderAvailableTimes() {
    const { business } = this.props
    const { adHocService } = this.state.service

    if (adHocService) {
      return (
        <AdHocView
          adHocService={adHocService}
          dateFormat={business.dateFormat}
          onTimeSelected={this.handleConfirm}
        />
      )
    }

    const { rescheduling, setCustomTitle, fieldsToAppointment } = this.props
    const calendarView = this.getCalendarView({ business })
    const fetchData = fieldsToAppointment()

    return (
      <MonthView
        business={business}
        fetchData={fetchData}
        setCustomTitle={setCustomTitle}
        rescheduling={rescheduling}
        onNav={this.onNav}
        calendarView={calendarView}
        onTimeSelected={this.handleConfirm}
      />
    )
  }

  renderCustomTimeButton() {
    if (this.props.isCustomTime || !this.props.business.allowTimeRequests || !this.props.endpoint) {
      return null
    }

    if (this.props.endpoint.resourceType === "appointment") {
      return null
    }

    return (
      <div className="request-time">
        <button className="btn btn-secondary" onClick={this.toggleCustomTime}>{ this.props.business.timeRequestButtonLabel || DEFAULT_TIME_REQUEST_BUTTON_LABEL }</button>
      </div>
    )
  }

  renderBody() {
    if (this.props.isCustomTime) {
      return (
        <div>
          <TimezonePicker timeStandard={this.props.business.dateFormat.timeStandard} />
          { this.renderCustomTime() }
        </div>
      )
    }

    return (
      <div>
        <TimezonePicker timeStandard={this.props.business.dateFormat.timeStandard} hidden={this.props.business.hideCustomerTimezoneDropdwon} />
        { this.renderAvailableTimes() }
        { this.renderCustomTimeButton() }
      </div>
    )
  }

  render() {
    return (
      <div style={{ position: 'relative' }}>
        { this.renderBody() }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  time: state.time,
  timezone: state.timezone,
  isCustomTime: state.isCustomTime,
  endpoint: state.endpoint,
})
export default connect(mapStateToProps)(InputDate)
